(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wh-pdp-trust"] && !Shopify.designMode) return;
  try {
    if(!window.whTrustReady){
    window.whTrustReady=true;
    document.addEventListener('click',(event)=>{
      const a=event.target.closest('a[href="#wh-size-guide"]');
      if(!a)return;
      const d=document.getElementById('wh-size-guide');
      if(d){d.open=true;}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
